import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import classNames from 'classnames';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import avatar from '@material-ui/core/colors/grey';
import grey from '@material-ui/core/colors/grey';
import red from '@material-ui/core/colors/red';
import orange from '@material-ui/core/colors/orange';
import green from '@material-ui/core/colors/green';

import * as routes from '../../../constants/routes';
import { startAddInvoice } from '../../../store/actions/invoices';
import { startEditAdmin } from '../../../store/actions/admin';
import { selectInvoiceStatus } from '../../../store/selectors';

const styles = theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing.unit,
  },
  avatar: {
    margin: '10px',
    color: '#fff',
    backgroundColor: avatar[500],
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
  },
  client: {
    width: "150px",
  },
  date: {
    width: "120px",
  },
  divider: {
    height: '30px',
    maxWidth: '2px',
    minWidth: '2px',
    margin: '0px 0px',
    background: grey[300],
  },
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: grey[100],
    }
  },
  statusMessage: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: "center",
  },
  statusMessageSpacer: {
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
    height: "7px",
    width: "7px",
    backgroundColor: "#bbb",
    borderRadius: "50%",
  },
  margin: {
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
  },
  status: {
    width: "100px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  total: {
    flexBasis: '80px',
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  flexGrow: {
    flexGrow: 1,
  },
});

class InvoiceDueCard extends Component {
  state = {
    open: false,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleCreate = () => {
    const { invoice, projectTasks, startEditAdmin, startAddInvoice, history } = this.props;
    const scheduleDate = new Date(invoice.scheduleDate.valueOf());
    const scheduleDueDate = new Date(invoice.scheduleDate.add(1, 'months').subtract(1, 'days').valueOf());

    startAddInvoice({
      projectId: invoice.projectId,
      clientId: invoice.clientId,
      projectTaskId: invoice.projectTaskId,
      invoiceDate: scheduleDate,
      dueDate: scheduleDueDate,
      projectTasks: projectTasks
    })
      .then(result => startEditAdmin({ invoice: result }))
      .then(() => {
        history.push(routes.INVOICES);
      });
  };

  render() {
    const {
      history,
      classes,
      invoice,
      client,
      project,
      projectTasks,
      status,
      startAddInvoice,
      startEditAdmin,
    } = this.props;
    const { open } = this.state;

    const statusColor = function () {
      switch (status.warningLevel) {
        case "overdue":
          return red[500];
        case "warning":
          return orange[500];
        case "ok":
          return green[500];
        default:
          return undefined;
      }
    }();

    return (
      <Card className={classes.root}>
        <Dialog
          open={open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Create Invoice"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              This action will create an invoice for this job. Do you want to create the invoice?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleCreate} color="primary" autoFocus>
              Create
            </Button>
          </DialogActions>
        </Dialog>

        <div
          className={classes.content}
          onClick={this.handleClickOpen.bind(this)}
        >
          <Avatar className={classes.avatar}>
            P
          </Avatar>
          <div className={classNames(classes.client, classes.margin)}>
            {client &&
              <Typography noWrap variant="subheading">
                {client.fullName}
              </Typography>
            }
            {project &&
              <Typography noWrap variant="caption">
                {project.jobCode}
              </Typography>
            }
          </div>
          <div className={classes.date}>
            {invoice.scheduleDate &&
              <Typography variant="subheading">
                {invoice.scheduleDate.format("MMM Do, YYYY")}
              </Typography>
            }
            {!invoice.scheduleDate && project.endDate &&
              <Typography variant="subheading">
                {moment(project.endDate).format("MMM Do, YYYY")}
              </Typography>
            }
          </div>
          {status.message &&
            <div className={classes.statusMessage}>
              <div className={classes.statusMessageSpacer} />
              <Typography style={{ color: statusColor }}>
                {status.message}
              </Typography>
            </div>
          }
          <div className={classes.flexGrow}/>
          <div className={classes.divider}></div>
          <Typography className={classes.total}>{`$0.00`}</Typography>
        </div>
        <div className={classes.divider}></div>
        <div className={classNames(classes.status, classes.margin)}>
          <Typography
            style={{ color: statusColor }}
            variant="subheading"
          >
            {status.name}
          </Typography>
        </div>
      </Card>
    );
  }
}


const mapStateToProps = (state, props) => {
  const { invoice } = props;
  const client = invoice.clientId === undefined
    ? undefined
    : state.clientsState.find(client => client.id === invoice.clientId);
  const project = invoice.projectId === undefined
    ? undefined
    : state.projectsState.find(project => project.id === invoice.projectId);
  const projectTasks = project === undefined
    ? undefined
    : state.projectTasksState.filter(projectTask => projectTask.projectId === project.id);

  return ({
    client,
    project,
    projectTasks,
    status: selectInvoiceStatus(state, invoice),
  });
};

const mapDispatchToProps = {
  startAddInvoice,
  startEditAdmin,
};

export default compose(
  withStyles(styles),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(InvoiceDueCard);



// WEBPACK FOOTER //
// ./src/components/admin/Invoices/InvoiceDueCard.jsx